import styled from 'styled-components';

const Wrapper = styled.div`
min-height: 100vh;
min-width: 100vw;
max-width: 100vw;
overflow-x: hidden;
background-color: black;
`;

export default Wrapper;